import CheckmarkCircleIcon from '@/app/icons/checkmark-circle'
import UserIcon from '@/app/icons/user'
import { giphyGreen } from '@giphy/colors'
import { IUser } from '@giphy/js-types'
import { Avatar } from 'ui'

export type Access = {
    channel: {
        avatar_url: string
        user_id: number
        display_name: string
        id: number
        slug: string
        url: string
    }
    create_datetime: string
    dashboard_url: string
    id: number
    last_login_datetime: string
    login_url: string
    permission_level: number
    update_datetime: string
}

export type AccessUser = {
    avatar: string
    avatar_url: string
    display_name: ''
    id: number
    is_verified: boolean
    profile_url: string
    username: string
    token: string
}

export type ChannelAccess = {
    access: Access[]
    emulated_user?: AccessUser | null
    user: AccessUser
}
export type AccessProps = {
    user: IUser & {
        channel_access?: {
            access: Access[]
            emulated_user?: IUser
            user?: IUser
        }
    }
}

const ListItem = ({
    user,
    href,
    isActive,
    isFirst,
}: {
    user: Partial<IUser>
    href: string
    isActive?: boolean
    isFirst?: boolean
}) => (
    <a href={href} className="flex min-h-[22px] cursor-pointer items-center gap-1 px-2 py-1 text-[13px] leading-[18px]">
        <div className="flex-shrink-0">
            <Avatar user={user} width={20} height={20} />
        </div>
        <div className={`overflow-hidden text-ellipsis whitespace-nowrap select-none ${isActive ? 'text-white' : ''}`}>
            {user.display_name || user.username}
        </div>
        {isActive && <CheckmarkCircleIcon width={16} height={16} color={giphyGreen} />}
        {!isActive && isFirst && (
            <>
                <UserIcon height={16} width={16} />
            </>
        )}
    </a>
)

const ChannelAccessMenu = ({ user }: AccessProps) => {
    const { channel_access } = user
    const firstUser = channel_access?.user || user
    return channel_access?.access?.length ? (
        <>
            <div className="ml-[18px] flex flex-col gap-1 pt-2">
                <ListItem
                    user={firstUser}
                    key={firstUser.id}
                    href={`/api/v4/channels/access/logout`}
                    isActive={channel_access.user?.id === channel_access.emulated_user?.id}
                    isFirst={true}
                />
                {channel_access?.access
                    .filter((access) => {
                        return access.channel.id !== channel_access.emulated_user?.id
                    })
                    .map((access) => {
                        return (
                            <ListItem
                                key={access.id}
                                user={access.channel}
                                href={access.login_url}
                                isActive={channel_access.emulated_user?.id === access.channel.user_id}
                            />
                        )
                    })}
            </div>
            <div className="mx-6 my-3 mt-5 h-0.5 w-[calc(100%-48px)] self-start border-[0.5px] bg-giphyWhite opacity-30 " />
        </>
    ) : null
}

export default ChannelAccessMenu
